import { useRacesList } from '../../races/contexts/races';

// Shared fields for animal create/edit (api-reference/admin-animals.md).
// `baptized` gobierna name/number: un animal bautizado requiere ambos; una cría
// pendiente (sin bautizar) puede guardarse sin ellos (decisión 0015).

const today = () => new Date().toLocaleDateString('en-CA');

export default function AnimalFields({ form, setField, fieldError, disabled, showStatus = false }) {
    const { data: racesData } = useRacesList({});
    const races = racesData?.items ?? [];
    const baptized = form.baptized !== false;

    return (
        <div className="cat-form__grid">
            <div className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Identificación</span>
                <div className="cat-form__toggle" role="group" aria-label="Estado de bautizo">
                    <button
                        type="button"
                        className={`cat-form__toggle-btn ${baptized ? 'cat-form__toggle-btn--active' : ''}`}
                        onClick={() => setField('baptized', true)}
                        disabled={disabled}
                    >
                        Bautizado
                    </button>
                    <button
                        type="button"
                        className={`cat-form__toggle-btn ${!baptized ? 'cat-form__toggle-btn--active' : ''}`}
                        onClick={() => setField('baptized', false)}
                        disabled={disabled}
                    >
                        Sin bautizar
                    </button>
                </div>
                {!baptized && <span className="cat-form__hint">Una cría pendiente de bautizo se guarda sin nombre ni número.</span>}
            </div>

            <label className="cat-form__field">
                <span className="cat-form__label">Nombre{baptized ? '' : ' (opcional)'}</span>
                <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setField('name', e.target.value)}
                    maxLength={120}
                    disabled={disabled}
                    autoFocus
                    aria-invalid={!!fieldError('name')}
                />
                {fieldError('name') && <span className="cat-form__error" role="alert">{fieldError('name')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Número / arete{baptized ? '' : ' (opcional)'}</span>
                <input
                    type="text"
                    value={form.number}
                    onChange={(e) => setField('number', e.target.value)}
                    maxLength={40}
                    disabled={disabled}
                    aria-invalid={!!fieldError('number')}
                />
                {fieldError('number') && <span className="cat-form__error" role="alert">{fieldError('number')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Registro</span>
                <input
                    type="text"
                    value={form.register}
                    onChange={(e) => setField('register', e.target.value)}
                    maxLength={60}
                    disabled={disabled}
                    placeholder="Opcional · único"
                    aria-invalid={!!fieldError('register')}
                />
                {fieldError('register') && <span className="cat-form__error" role="alert">{fieldError('register')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Raza</span>
                <select value={form.race_id} onChange={(e) => setField('race_id', e.target.value)} disabled={disabled} aria-invalid={!!fieldError('race_id')}>
                    <option value="">Seleccionar…</option>
                    {races.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
                </select>
                {fieldError('race_id') && <span className="cat-form__error" role="alert">{fieldError('race_id')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Sexo</span>
                <select value={form.sex} onChange={(e) => setField('sex', e.target.value)} disabled={disabled} aria-invalid={!!fieldError('sex')}>
                    <option value="">Seleccionar…</option>
                    <option value="female">Hembra</option>
                    <option value="male">Macho</option>
                </select>
                {fieldError('sex') && <span className="cat-form__error" role="alert">{fieldError('sex')}</span>}
            </label>

            <label className="cat-form__field">
                <span className="cat-form__label">Nacimiento</span>
                <input
                    type="date"
                    value={form.birth}
                    max={today()}
                    onChange={(e) => setField('birth', e.target.value)}
                    disabled={disabled}
                    aria-invalid={!!fieldError('birth')}
                />
                {fieldError('birth') && <span className="cat-form__error" role="alert">{fieldError('birth')}</span>}
            </label>

            <label className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Apariencia</span>
                <input
                    type="text"
                    value={form.appearance}
                    onChange={(e) => setField('appearance', e.target.value)}
                    maxLength={255}
                    disabled={disabled}
                    placeholder="Pelaje, marcas, señas (opcional)"
                    aria-invalid={!!fieldError('appearance')}
                />
                {fieldError('appearance') && <span className="cat-form__error" role="alert">{fieldError('appearance')}</span>}
            </label>

            <label className="cat-form__field cat-form__field--full">
                <span className="cat-form__label">Descripción</span>
                <textarea
                    value={form.description}
                    onChange={(e) => setField('description', e.target.value)}
                    rows={3}
                    disabled={disabled}
                    placeholder="Notas adicionales (opcional)"
                    aria-invalid={!!fieldError('description')}
                />
                {fieldError('description') && <span className="cat-form__error" role="alert">{fieldError('description')}</span>}
            </label>

            {showStatus && (
                <label className="cat-form__field">
                    <span className="cat-form__label">Estado</span>
                    <select value={form.status} onChange={(e) => setField('status', Number(e.target.value))} disabled={disabled}>
                        <option value={2}>Activo</option>
                        <option value={1}>Inactivo</option>
                    </select>
                </label>
            )}
        </div>
    );
}
